const hexToRgb = (hex) => {
  const h = (hex || '').replace('#', '').trim();
  if (h.length !== 6) return '255,255,255';
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `${r},${g},${b}`;
};

const PulsePingIcon = ({ playKey, bgColor, index }) => {
  return (
    <div
      key={playKey}
      className="pingWrap"
      style={{
        backgroundColor: bgColor,
        '--ping-rgb': hexToRgb(bgColor),
        color: 'inherit'
      }}
      aria-hidden="true"
    >
      <span className="pingCore" />
      <span className="pingWave wave--mid" />
      <span className="pingWave wave--outer" />
      <span className="ping-text">{index + 1}</span>
    </div>
  );
};

export default PulsePingIcon;
